import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gallery',
    templateUrl: './component.html',
    styleUrls: ['./component.css']
})
export class GalleryComponent implements OnInit {

    public news = [
        {
            title: "IISc",
            Description: "",
            ShortDescription: '',
            Thumbnail: '',
            Image: ['assets/img/website-new/iisc/iisc-1.jpg', 'assets/img/website-new/iisc/iisc-3.jpg', 'assets/img/website-new/iisc/iisc-2.jpg'],
            Date: '',
            newsid: 'newsid001'
        },
        {
            title: "UNIBIC",
            Description: "",
            ShortDescription: '',
            Thumbnail: '',
            Image: ['assets/img/website-new/unibic/unibic-1.jpg', 'assets/img/website-new/unibic/unibic-3.jpg', 'assets/img/website-new/unibic/unibic-2.jpg'],
            Date: '',
            newsid: 'newsid001'
        },
        {
            title: "VIDYA SUVARNA-SOUVENIR",
            Description: "",
            ShortDescription: '',
            Thumbnail: '',
            Image: ['assets/img/website-new/vidya-suvarna/1.jpg', 'assets/img/website-new/vidya-suvarna/2.jpg', 'assets/img/website-new/vidya-suvarna/3.jpg', 'assets/img/website-new/vidya-suvarna/4.jpg', 'assets/img/website-new/vidya-suvarna/5.jpg', 'assets/img/website-new/vidya-suvarna/6.jpg', 'assets/img/website-new/vidya-suvarna/7.jpg', 'assets/img/website-new/vidya-suvarna/8.jpg', 'assets/img/website-new/vidya-suvarna/9.jpg', 'assets/img/website-new/vidya-suvarna/10.jpg', 'assets/img/website-new/vidya-suvarna/11.jpg', 'assets/img/website-new/vidya-suvarna/12.jpg', 'assets/img/website-new/vidya-suvarna/13.jpg'],
            Date: '',
            newsid: 'newsid001'
        },
        {
            title: "YOGA DAY",
            Description: "",
            ShortDescription: '',
            Thumbnail: '',
            Image: ['assets/img/website-new/yoga-day/1.jpg', 'assets/img/website-new/yoga-day/2.jpg'],
            Date: '',
            newsid: 'newsid001'
        }
    ];
    //public selectedNewsId = this.service.selectedNewsId;

    constructor() { }

    ngOnInit() {
    }



}
